import { MEDIA_QUERY_LIST } from '../../_modules/device_decision';

const mediaQuery = {
  data() {
    return {
      media: MEDIA_QUERY_LIST.matches,
    };
  },
  created() {
    window.addEventListener('resize', () => {
      if (this.media === MEDIA_QUERY_LIST.matches) return;
      this.media = MEDIA_QUERY_LIST.matches;
    });
  },
};

export default mediaQuery;
